/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Frankatur } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * FrankaturService - axios parameter creator
 * @export
 */
export const FrankaturServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Frankatur
         * @summary Frankatur
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrankaturById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFrankaturById', 'id', id)
            const localVarPath = `/api/frankaturen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Frankaturen
         * @summary Frankaturen
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrankaturen: async (mandant?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/frankaturen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mandant !== undefined) {
                localVarQueryParameter['mandant'] = mandant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrankaturService - functional programming interface
 * @export
 */
export const FrankaturServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrankaturServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Frankatur
         * @summary Frankatur
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrankaturById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Frankatur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrankaturById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Frankaturen
         * @summary Frankaturen
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrankaturen(mandant?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Frankatur>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrankaturen(mandant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FrankaturService - factory interface
 * @export
 */
export const FrankaturServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrankaturServiceFp(configuration)
    return {
        /**
         * Liefert eine Frankatur
         * @summary Frankatur
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrankaturById(id: number, options?: any): AxiosPromise<Frankatur> {
            return localVarFp.getFrankaturById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Frankaturen
         * @summary Frankaturen
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrankaturen(mandant?: number, options?: any): AxiosPromise<Array<Frankatur>> {
            return localVarFp.getFrankaturen(mandant, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FrankaturService - interface
 * @export
 * @interface FrankaturService
 */
export interface FrankaturServiceInterface {
    /**
     * Liefert eine Frankatur
     * @summary Frankatur
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrankaturServiceInterface
     */
    getFrankaturById(id: number, options?: any): AxiosPromise<Frankatur>;

    /**
     * Liefert eine Liste von Frankaturen
     * @summary Frankaturen
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrankaturServiceInterface
     */
    getFrankaturen(mandant?: number, options?: any): AxiosPromise<Array<Frankatur>>;

}

/**
 * FrankaturService - object-oriented interface
 * @export
 * @class FrankaturService
 * @extends {BaseAPI}
 */
export class FrankaturService extends BaseAPI implements FrankaturServiceInterface {
    /**
     * Liefert eine Frankatur
     * @summary Frankatur
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrankaturService
     */
    public getFrankaturById(id: number, options?: any) {
        return FrankaturServiceFp(this.configuration).getFrankaturById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Frankaturen
     * @summary Frankaturen
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrankaturService
     */
    public getFrankaturen(mandant?: number, options?: any) {
        return FrankaturServiceFp(this.configuration).getFrankaturen(mandant, options).then((request) => request(this.axios, this.basePath));
    }
}
